var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppleCalendar = function SvgAppleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "apple-calendar")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple-calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5947672,18.410441 C51.2812922,18.6534653 45.746837,21.769577 45.746837,28.6984698 C45.746837,36.7128713 52.7892151,39.5481548 53,39.6183618 C52.9675716,39.7911791 51.8812185,43.5013501 49.2869426,47.2817282 C46.9737133,50.6084608 44.5577939,53.929793 40.8825697,53.929793 C37.2073455,53.929793 36.2615158,51.7965797 32.0187938,51.7965797 C27.8841666,51.7965797 26.4140769,54 23.0523277,54 C19.6905786,54 17.3449208,50.9216922 14.6479548,47.1413141 C11.5240142,42.7020702 9,35.8055806 9,29.260126 C9,18.7614761 15.8315932,13.1935194 22.5550915,13.1935194 C26.1276256,13.1935194 29.1056381,15.5373537 31.3486058,15.5373537 C33.4834787,15.5373537 36.8127994,13.0531053 40.877165,13.0531053 C42.4175163,13.0531053 47.9519715,13.1935194 51.5947672,18.410441 Z M38.9476723,8.60846085 C40.6285469,6.61566157 41.81759,3.85058506 41.81759,1.08550855 C41.81759,0.702070207 41.7851615,0.313231323 41.7148999,0 C38.9801007,0.102610261 35.7264464,1.819982 33.7645252,4.09360936 C32.2241739,5.84338434 30.7865127,8.60846085 30.7865127,11.4113411 C30.7865127,11.8325833 30.8567744,12.2538254 30.8892028,12.3888389 C31.0621545,12.4212421 31.3432011,12.4590459 31.6242476,12.4590459 C34.0780002,12.4590459 37.1641076,10.8172817 38.9476723,8.60846085 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
};
export default SvgAppleCalendar;